/**
 * ifm转发
 * @author 郁蘅(manda.zm@alibaba-inc.com)
 * @date 2015/month/day
 */

var $ = require('@alife/alpha-jquery/jquery.js');
var Base = require('@alife/alpha-base/base');
var tpl = require('./ifm-forward.tpl');
var Handlebars = require('@alife/alpha-handlebars/handlebars');

var URL = '//message.alibaba.com/message/ajax/recommend/getRecommendSellers.htm';
// var UtmModel = require('@alife/alpha-utm-model/utm-model');

Handlebars.registerHelper('I18N4IFMFWD', function(key) {
    if (key) {
        return I18N.app[key] || '';
    }
    return '';
});

var IfmForward = Base.extend({
    attrs: {
        data: null,
        trigger: ''
    },
    events: {
        'click [data-role=recommend-product]': 'clickStat'
    },
    renderUI: function(data) {
        var content = Handlebars.compile(tpl)(data);
        this.get('trigger').append(content);
        // this.bindUI();
        // this.model.exposeStat();
    },
    //场景id为3123
    startRender: function() {
        var config = this.get('data');
        var self = this;
        var params = {secProductId: config.secProductId};

        $.ajax({
            dataType: 'json',
            url: URL,
            data: {
                params: JSON.stringify(params),
                _csrf_token_: config._csrf_token_ || ''
            },
            success: function(result){
                var items = result.data && result.data.items ? result.data.items : [];
                items = items.length > 4 ? items.slice(0, 4) : items;
                if(items.length) {
                    self.renderUI(items);
                }
            }
        });
        // this.model = new UtmModel({
        //     language: config.language ? config.language : '',
        //     aminMemberSeq: config.aminMemberSeq ? config.aminMemberSeq : '',
        //     sceneId: (config.sceneId) ? config.sceneId : '3123',
        //     perPage: config.perPage ? config.perPage : 4,
        //     productId: config.productId ? config.productId : '',
        //     categoryId: config.categoryId ? config.categoryId : ''
        // });

        // this.model.done(function(items) {
        //     items = items.length > 4 ? items.slice(0, 4) : items;
        //     self.renderUI(items);
        // }).fail(function() {

        // });
    }
    // bindUI: function() {
    //     var self = this;
    //     this.element = this.get('trigger');
    //     this.element.find('[data-role=recommend-product]').on('click', function(e) {
    //         self.clickStat(e);
    //     });
    // },
    //打点
    // clickStat: function(e){
    //     var $target = $(e.currentTarget),
    //         url = $target.attr('data-url'),
    //         id = $target.attr('data-id'),
    //         area = $target.attr('data-area');
    //     this.model.clickStat({
    //         id: id,
    //         area: area
    //     });
    //     window.open(url,'_blank');
    // }
});

module.exports = IfmForward;
